import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { connect } from 'react-redux';
const ProtectedPage = ({ children, isLoggedIn }) => {
    const location = useLocation();
    const redirectPath = location.pathname.startsWith('/') ? location.pathname.substring(1) : location.pathname;
    return (
        isLoggedIn ? children : <Navigate to={`/login?redirect_path=${redirectPath}${location.search}`} />
    )
}

const mapStateToProps = state => ({
    isLoggedIn: state.userPage.isLoggedIn,
    user: state.userPage.loggedUser
});

export const ProtectedRoute = connect(mapStateToProps, {})(ProtectedPage);